import apiClient from "./api";
const PACIENTE_API_BASE_URL = "/pacientes";
class PacienteService {
  getPacientes() {
    return apiClient.get(PACIENTE_API_BASE_URL);
  }
  agregarPaciente(paciente) {
    return apiClient.post(PACIENTE_API_BASE_URL, paciente);
  }
  updatePaciente(paciente, pacienteId) {
    return apiClient.put(PACIENTE_API_BASE_URL + "/" + pacienteId, paciente);
  }

  patchPaciente(paciente, pacienteId) {
    return apiClient.patch(PACIENTE_API_BASE_URL + "/" + pacienteId, paciente);
  }

  deletePaciente(pacienteId) {
    return apiClient.delete(PACIENTE_API_BASE_URL + "/" + pacienteId);
  }
async buscarPacientes(busqueda) {
    try {
      const response = await apiClient.post(`${PACIENTE_API_BASE_URL}/buscar`, { busqueda });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

   async getPacientePorId(pacienteId) {
    try {
      const response = await apiClient.get(
        `${PACIENTE_API_BASE_URL}/${pacienteId}`,
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}
export default new PacienteService();